export const colors = {
  primary: '#4478B5',
  button: '#5697D4',
  buttonHover: '#4A8BC6',
  secondary: '#D9A85A',
  text: '#424242',
  mutedText: '#757575',
  border: '#E0E0E0',
  footerBorder: '#E0E0E0',
  leftBackground: '#EFF7FF',
  leftBackgroundEnd: '#FFF9EF'
};

export const pageSx = {
  bgcolor: '#FFFFFF',
  color: colors.text,
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'Inter',

  height: '100dvh',
  minHeight: 0,
  margin: 0,
  maxWidth: 'none',
  overflowX: 'hidden',
  overflowY: 'auto',
  padding: 0,
  width: '100%',

  WebkitOverflowScrolling: 'touch',
   '&::-webkit-scrollbar': {
    display: 'none'
  },

  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
};

export const headerSx = {
  bgcolor: '#FFFFFF',
  boxShadow: 'none',
  color: colors.text,
  flexShrink: 0,
  position: 'relative',
  width: '100%',
  zIndex: 2
};

export const toolbarSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 2,
  height: 64,
  justifyContent: 'space-between',
  minHeight: '64px !important',
  width: '100%',
  px: {
    xs: 2,
    sm: 3,
    md: 4.5
  }
};

export const logoSx = {
  display: 'block',
  height: 'auto',
  width: {
    xs: 105,
    sm: 120
  }
};

export const headerActionsSx = {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  gap: 1.5,
  justifyContent: 'flex-end'
};

export const searchWrapperSx = {
  alignItems: 'center',
  bgcolor: '#FFFFFF',
  border: '1px solid #E1E1E1',
  borderRadius: '4px',
  display: {
    xs: 'none',
    sm: 'flex'
  },
  height: 35,
  maxWidth: 368,
  width: '100%'
};

export const searchInputSx = {
  color: colors.text,
  flex: 1,
  fontSize: 13,
  height: '100%',
  px: 1.5,

  '& input::placeholder': {
    color: '#757575',
    opacity: 1
  }
};

export const searchIconSx = {
  color: '#757575',
  height: 34,
  width: 38,

  '&:hover': {
    bgcolor: '#F5F5F5'
  },

  '& svg': {
    fontSize: 18
  }
};

export const registerButtonSx = {
  bgcolor: colors.secondary,
  borderRadius: '4px',
  boxShadow: 'none',
  color: '#FFFFFF',
  fontWeight: 500,
  height: 35,
  px: 2,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',

  '&:hover': {
    bgcolor: '#CC963E',
    boxShadow: 'none'
  },

  '& .MuiButton-startIcon': {
    mr: 0.75
  },

  '& .MuiButton-startIcon svg': {
    fontSize: 16
  }
};
export const accentLineSx = {
  background: `linear-gradient(
    90deg,
    ${colors.primary} 0%,
    ${colors.button} 48%,
    ${colors.secondary} 100%
  )`,
  flexShrink: 0,
  height: 4,
  width: '100%'
};

export const contentSx = {
// background: `linear-gradient(
//   90deg,
//   ${colors.leftBackground} 0%,
//   ${colors.leftBackground} 20%,
//   ${colors.leftBackgroundEnd} 100%,
// )`,
background: `linear-gradient(
    110deg,
    ${colors.leftBackground} 0%,
    ${colors.leftBackground} 48%,
    ${colors.leftBackgroundEnd} 100%
  )`,
  display: 'flex',
  flex: 1,
  position: 'relative',

  '&::before': {
    background:
      'radial-gradient(circle, rgba(68, 120, 181, 0.13) 1px, transparent 1px)',
    backgroundSize: '28px 28px',
    bottom: 30,
    content: '""',
    left: 0,
    maskImage:
      'linear-gradient(to right, rgba(0,0,0,0.9), transparent)',
    opacity: 0.6,
    position: 'absolute',
    width: '48%'
  }
};

export const mainContentSx = {
  alignItems: 'stretch', // don't use center
  display: 'grid',
  flex: 1,
  gap: {
    xs: 4,
    md: 7,
    lg: 10
  },
  gridTemplateColumns: {
    xs: '1fr',
    md: 'minmax(0, 1.2fr) minmax(360px, 0.8fr)'
  },
  margin: '0 auto',
  minHeight: {
    xs: 'auto',
    md: 'calc(100vh - 148px)',
  },
  px: {
    xs: 2,
    sm: 4,
    md: 10
  },
  py: {
    xs: 5,
    md: 2
  },
  position: 'relative',
  width: '100%',
  zIndex: 1
};

export const heroSectionSx = {
  alignItems: 'center',
  display: 'flex',
  height: {
    xs: 'auto',
    md: 'calc(100vh - 148px)'
  },
  justifyContent: {
    xs: 'center',
    md: 'flex-start'
  },
  minWidth: 0
};

export const heroContentSx = {
  maxWidth: 700,
  position: 'relative',
  width: '100%'
};

export const trustBadgeSx = {
  alignItems: 'center',
  bgcolor: '#FFFFFF',
  border: `1px solid ${colors.border}`,
  borderRadius: '18px',
  boxShadow: '0 3px 10px rgba(68, 120, 181, 0.1)',
  display: 'inline-flex',
  gap: 0.75,
  mb: 2.25,
  px: 1.2,
  py: 0.65
};

export const trustBadgeIconSx = {
  color: colors.button,
  fontSize: 16
};

export const trustBadgeTextSx = {
  color: colors.primary,
  fontSize: 11,
  fontWeight: 600
};

export const heroTitleSx = {
  color: colors.primary,
  fontSize: {
    xs: 38,
    sm: 46,
    md: 48
  },
  fontWeight: 700,
  letterSpacing: '-1.4px',
  lineHeight: 1.04,
  mb: 0
};

export const heroDescriptionSx = {
  color: colors.mutedText,
  fontSize: {
    xs: 13,
    md: 18
  },
  lineHeight: 1.4,
  maxWidth: 600
};

export const heroHeadingAccentSx = {
  background: `linear-gradient(
    90deg,
    ${colors.primary},
    ${colors.secondary}
  )`,
  borderRadius: '2px',
  height: 1.75,
  mb: 2.2,
  mt: 2.3,
  width: 120
};

export const heroCaptionSx = {
  alignItems: 'center',
  color: colors.mutedText,
  display: 'flex',
  flexWrap: 'wrap',
  fontSize: 12,
  fontWeight: 500,
  gap: 1
};

export const heroCaptionDotSx = {
  bgcolor: colors.primary,
  borderRadius: '50%',
  height: 4,
  width: 4
};

export const heroIllustrationSx = {
  height: {
    xs: 205,
    sm: 245,
    md: 270
  },
  mt: 2.5,
  position: 'relative',
  width: {
    xs: '100%',
    sm: 470,
    md: 510
  }
};

export const heroIllustrationGlowSx = {
  background:
    'radial-gradient(ellipse, rgba(86, 151, 212, 0.22), transparent 68%)',
  bottom: 0,
  filter: 'blur(4px)',
  height: 110,
  left: '6%',
  position: 'absolute',
  width: '84%'
};

export const heroIllustrationCardSx = {
  bgcolor: '#FFFFFF',
  border: `1px solid ${colors.border}`,
  borderRadius: '8px',
  bottom: 28,
  // boxShadow: '0 1px 3px rgba(16,95,161,.04),0 8px 24px rgba(16,95,161,.12)',
  boxShadow: '0 18px 35px rgba(68, 120, 181, 0.16)',
  height: {
    xs: 130,
    sm: 155,
    md: 165
  },
  left: {
    xs: '8%',
    sm: '9%'
  },
  overflow: 'hidden',
  position: 'absolute',
  transform: 'perspective(600px) rotateY(5deg) rotateX(2deg)',
  width: {
    xs: '72%',
    sm: '68%'
  }
};

export const heroIllustrationScreenSx = {
  bgcolor: '#FFFFFF',
  display: 'flex',
  gap: 1.5,
  height: '100%',
  p: 1.5
};

export const heroIllustrationLockSx = {
  alignItems: 'center',
  background: `linear-gradient(
    145deg,
    ${colors.leftBackground},
    rgba(86, 151, 212, 0.35)
  )`,
  border: '4px solid rgba(255,255,255,0.8)',
  borderRadius: '24px 24px 30px 30px',
  bottom: 25,
  boxShadow: '0 12px 25px rgba(68, 120, 181, 0.22)',
  color: colors.primary,
  display: 'flex',
  height: {
    xs: 72,
    sm: 88
  },
  justifyContent: 'center',
  position: 'absolute',
  right: {
    xs: '10%',
    sm: '15%'
  },
  width: {
    xs: 62,
    sm: 74
  },

  '& > svg:first-of-type': {
    fontSize: {
      xs: 68,
      sm: 82
    },
    position: 'absolute'
  },

  '& > svg:last-of-type': {
    color: '#FFFFFF',
    fontSize: {
      xs: 22,
      sm: 26
    },
    position: 'relative',
    zIndex: 1
  }
};

export const signInSectionSx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: {
    xs: 'center',
    md: 'flex-end'
  },
  minWidth: 0
};

export const formWrapperSx = {
  bgcolor: '#FFFFFF',
  border: `1px solid ${colors.border}`,
  borderRadius: '12px',
  boxShadow:
    '0 14px 34px rgba(66, 66, 66, 0.09), 0 2px 6px rgba(66, 66, 66, 0.04)',
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  
  maxWidth: 410,
  p: {
    xs: 3,
    sm: 4
  },
  width: '100%'
};

export const signInTitleSx = {
  color: colors.primary,
  fontSize: 24,
  fontWeight: 700,
  lineHeight: 1.2
};

export const signInSubtitleSx = {
  color: colors.mutedText,
  fontSize: 12,
  mt: 0,
  mb:'16px'
};

export const fieldLabelSx = {
  color: colors.text,
  display: 'block',
  fontSize: 11,
  fontWeight: 600,
  mb: 0.5,
  textTransform: 'uppercase',
  fontFamily:'Inter'
};

export const requiredSx = {
  color: '#D9534F',
  display: 'inline',
  ml: 0.3
};

export const formControlSx = {
  '& .MuiOutlinedInput-root': {
    bgcolor: '#FFFFFF',
    borderRadius: '4px',
    color: colors.text,
    fontSize: 12,
    height: 42,
    boxShadow:'none',

    '& fieldset': {
      borderColor: colors.border
    },

    '&:hover fieldset': {
      borderColor: colors.button
    },

    '&.Mui-focused fieldset': {
      borderColor: colors.primary,
      borderWidth: '1px'
    }
  },

  '& .MuiInputAdornment-root svg': {
    color: colors.mutedText,
    fontSize: 18
  },

  '& .MuiOutlinedInput-input': {
    py: 1.2
  },

  '& .MuiOutlinedInput-input::placeholder': {
    color: colors.mutedText,
    opacity: 0.7
  },

  '& .MuiFormHelperText-root': {
    fontSize: 10,
    marginLeft: 0,
    mt: 0.5
  }
};

export const passwordIconButtonSx = {
  color: colors.mutedText,
  mr: -0.5,

  '& svg': {
    fontSize: 17
  },

  '&:hover': {
    bgcolor: colors.leftBackground,
    color: colors.primary
  }
};

export const forgotLinksSx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  mt: -0.5
};

export const forgotLinkSx = {
  color: colors.primary,
  fontSize: 12,
  fontWeight: 500,
  textDecoration: 'none',

  '&:hover': {
    color: colors.buttonHover,
    textDecoration: 'underline'
  }
};

export const dividerSx = {
  color: colors.border,
  fontSize: 10,
  mx: 0.8
};

export const signInButtonSx = {
  bgcolor: colors.button,
  borderRadius: '4px',
  boxShadow: '0 4px 10px rgba(86, 151, 212, 0.22)',
  color: '#FFFFFF',
  fontSize: 11,
  fontWeight: 600,
  height: 40,
  mt: 0.5,
  textTransform: 'uppercase',

  '&:hover': {
    bgcolor: colors.buttonHover,
    boxShadow: '0 5px 14px rgba(86, 151, 212, 0.3)'
  },

  '&.Mui-disabled': {
    bgcolor: '#F5F5F5',
    color: '#757575',
    boxShadow: 'none'
  }
};

export const newPracticeSx = {
  color: colors.mutedText,
  fontSize: 10.5,
  textAlign: 'center'
};

export const registerLinkSx = {
  color: colors.secondary,
  fontSize: 12,
  fontWeight: 500,
  ml: 0.5,
  textDecoration: 'none',

  '&:hover': {
    color: colors.secondary,
    filter: 'brightness(0.88)',
    textDecoration: 'underline'
  }
};

export const footerSx = {
  bgcolor: '#FFFF',
  borderTop: `1px solid ${colors.footerBorder}`,
  flexShrink: 0
};

export const footerContentSx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0 auto',
  minHeight: 40,
  px: {
    xs: 2,
    sm: 3,
    md: 10
  },
  py: {
    xs: 1.5,
    sm: 0
  },
  width: '100%'
};

export const footerLeftSx = {
  alignItems: 'center',
  display: {
    xs: 'none',
    sm: 'flex'
  },
  gap: 1.2
};

export const footerSecurityIconSx = {
  alignItems: 'center',
  bgcolor: colors.leftBackground,
  border: `1px solid ${colors.footerBorder}`,
  borderRadius: '50%',
  color: colors.button,
  display: 'flex',
  height: 30,
  justifyContent: 'center',
  width: 30,

  '& svg': {
    fontSize: 17
  }
};

export const footerLinksSx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: {
    xs: 'center',
    sm: 'flex-end'
  },
  width: {
    xs: '100%',
    sm: 'auto'
  }
};

export const footerTextSx = {
  color: colors.mutedText,
  fontSize: 11,
  lineHeight: 1.5
};

export const footerDividerSx = {
  color: colors.footerBorder,
  fontSize: 10,
  mx: 1
};

export const footerLinkSx = {
  color: colors.secondary,
  fontSize: 11,
  fontWeight:500,
  textDecoration: 'none',

  '&:hover': {
    color: colors.secondary,
    filter: 'brightness(0.88)',
    textDecoration: 'underline'
  }
};